import '../css/rolex-v7.less';

import { scrollIntoView } from 'seamless-scroll-polyfill';
// import Pristine from 'pristinejs';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock-upgrade';
// import smoothScroll from './modules/smooth-scrolling';
import Flickity from 'flickity';

import './rolex/contact-form';
import './rolex/map';
import './rolex/watch-grid';
import './rolex/analytics';

// // some of the sliders position the buttons centered to the image, not the entire slide

const positionSliderBtns = () => {
  let sliders = document.querySelectorAll('.js-rlx-ke-slider');

  sliders.forEach((elem) => {
    let btns = elem.querySelectorAll<HTMLInputElement>('.js-prev, .js-next');

    let sliderImage = elem.querySelector('.js-slide img') as HTMLElement;

    btns.forEach((btn) => {
      btn.style.top = `${sliderImage?.offsetHeight / 2}px`;
    });
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  const nav = document.querySelector('.js-rlx-nav') as HTMLElement;
  const navToggle = document.querySelector('.js-toggle-rlx-nav') as HTMLButtonElement;
  const navDropdown = document.querySelector('.js-rlx-nav-dropdown') as HTMLElement;

  navToggle.addEventListener('click', (e) => {
    e.preventDefault();

    if (navDropdown.classList.contains('open')) {
      navToggle.classList.remove('open');
      navDropdown.classList.remove('open');
      navDropdown.setAttribute('aria-hidden', 'true');
      clearAllBodyScrollLocks();
    } else {
      scrollIntoView(nav, { behavior: 'smooth' });
      navToggle.classList.add('open');
      navDropdown.classList.add('open');
      navDropdown.removeAttribute('aria-hidden');
      disableBodyScroll(navDropdown);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1649) {
      if (nav) {
        navToggle.classList.remove('open');
        navDropdown.classList.remove('open');
        navDropdown.removeAttribute('aria-hidden');
      }
    }
  });

  const navLinks = document.querySelectorAll<HTMLAnchorElement>(
    '.rlx-header__nav-link',
  );

  // Check breadcrumbs to see if it has a parent page. If there are only two that means its not a child page

  // Select all elements with the class 'rlx-breadcrumbs__link'
  const breadcrumbLinks = document.querySelectorAll<HTMLAnchorElement>('.rlx-breadcrumbs__link');

  // Convert the NodeList to an array
  const breadcrumbLinkArray = Array.from(breadcrumbLinks);

  // Ensure there is at least one element and remove the first element (ie remove the rolex landing page)
  if (breadcrumbLinkArray.length !== 0) {
    breadcrumbLinkArray.shift();
  }

  navLinks?.forEach((link) => {
    // Check if the link's href matches the current URL or its parents
    if (link.href === document.URL) {
      link.classList.add('active');
      return;
    } else if (breadcrumbLinkArray.length) {
      breadcrumbLinkArray.forEach((breadcrumb) => {
        if (link.href === breadcrumb.href) {
          link.classList.add('active');
          return;
        }
      });
    }
  });
});

// Hero slider

function toggleButtonClass(element: HTMLInputElement, mode: 'light' | 'dark'): void {
  if (mode === 'light') {
    element.classList.add('rlx-slider-btn--light');
    element.classList.remove('rlx-slider-btn--dark');
  } else {
    element.classList.add('rlx-slider-btn--dark');
    element.classList.remove('rlx-slider-btn--light');
  }
}

const heroSliders = document.querySelectorAll('.js-rlx-hero-slider');

heroSliders.forEach((elem) => {
  let slider = new Flickity(elem, {
    cellSelector: '.js-slide',
    wrapAround: false,
    cellAlign: 'left',
    prevNextButtons: false,
    selectedAttraction: 0.012,
  });

  let prev = elem.querySelector('.js-prev') as HTMLInputElement;
  let next = elem.querySelector('.js-next') as HTMLInputElement;

  prev?.addEventListener('click', () => {
    slider.previous();
  });

  next?.addEventListener('click', () => {
    slider.next();
  });

  let slides = slider.getCellElements();

  slider.on('change', (index) => {
    let numSlides = slider.slides.length;
    const style = slides[index].dataset.style ?? 'light';

    toggleButtonClass(prev, style);
    toggleButtonClass(next, style);

    if (style === 'light') {
      elem.classList.add('rlx-slider--light');
      elem.classList.remove('rlx-slider--dark');
    } else {
      elem.classList.add('rlx-slider--dark');
      elem.classList.remove('rlx-slider--light');
    }

    if (index === 0) {
      prev?.setAttribute('disabled', 'true');
      next?.removeAttribute('disabled');
    } else if (index === numSlides - 1) {
      prev?.removeAttribute('disabled');
      next?.setAttribute('disabled', 'true');
    } else {
      prev?.removeAttribute('disabled');
      next?.removeAttribute('disabled');
    }
  });
});

let hoursToggle = document.querySelector('.js-rlx-hours-toggle');

hoursToggle?.addEventListener('click', (e) => {
  e.preventDefault();

  let rolexHours = document.querySelector('.js-rlx-hours') as HTMLElement;

  if (rolexHours && rolexHours.classList.contains('open')) {
    hoursToggle?.classList.remove('open');
    rolexHours.style.maxHeight = '';
    rolexHours.classList.remove('open');
    rolexHours.setAttribute('aria-hidden', 'true');
  } else {
    hoursToggle?.classList.add('open');
    rolexHours.style.maxHeight = `${rolexHours.scrollHeight}px`;
    rolexHours.classList.add('open');
    rolexHours.removeAttribute('aria-hidden');
  }
});

const keSliders = document.querySelectorAll('.js-rlx-ke-slider');

keSliders.forEach((elem) => {
  let slider = new Flickity(elem, {
    cellSelector: '.js-slide',
    wrapAround: false,
    cellAlign: 'left',
    prevNextButtons: false,
    groupCells: true,
    selectedAttraction: 0.012,
    contain: true,
  });

  let prev = elem.querySelector('.js-prev');
  let next = elem.querySelector('.js-next');

  prev?.addEventListener('click', () => {
    slider.previous();
  });

  next?.addEventListener('click', () => {
    slider.next();
  });

  slider.on('change', () => {
    let numSlides = slider.slides.length;
    let index = slider.selectedIndex;

    if (index === 0) {
      prev?.setAttribute('disabled', 'true');
      next?.removeAttribute('disabled');
    } else if (index === numSlides - 1) {
      prev?.removeAttribute('disabled');
      next?.setAttribute('disabled', 'true');
    } else {
      prev?.removeAttribute('disabled');
      next?.removeAttribute('disabled');
    }
  });

  positionSliderBtns();
});

// when slider images load we need to fire a resize to adjust slider
let sliderImages = document.querySelectorAll('.js-slide img');

Array.from(sliderImages).forEach((img) => {
  img.addEventListener('load', () => {
    window.dispatchEvent(new Event('resize'));
    positionSliderBtns();
  });
});

window.onresize = positionSliderBtns;

// // Tooltip
const mouse = new Event('mouseclick');
const touch = new Event('touch');

document.addEventListener('pointerdown', ({ pointerType, target }) => {
  if (pointerType === 'mouse') {
    (target as HTMLElement)?.dispatchEvent(mouse);
  }
  if (pointerType === 'touch') {
    (target as HTMLElement)?.dispatchEvent(touch);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll<HTMLElement>('.js-tooltip-trigger');

  tooltips.forEach((tooltip) => {
    const content = tooltip.nextElementSibling as HTMLElement | null;

    if (content) {
      const showTooltip = () => content.removeAttribute('aria-hidden');
      const hideTooltip = (event: MouseEvent) => {
        if (!tooltip.contains(event.relatedTarget as Node) && !content.contains(event.relatedTarget as Node)) {
          content.setAttribute('aria-hidden', 'true');
        }
      };

      tooltip.addEventListener('mouseover', showTooltip);
      tooltip.addEventListener('mouseleave', hideTooltip);
      tooltip.addEventListener('focusin', showTooltip);
      tooltip.addEventListener('blur', hideTooltip);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const accordionBtns = document.querySelectorAll('.js-rlx-accordion-toggle');

  accordionBtns?.forEach((btn) => {
    const parent = btn.closest('.js-rlx-accordion-item');

    // grab panel
    const panel = parent?.querySelector<HTMLElement>('.js-rlx-accordion-panel');

    if (panel && panel?.classList.contains('rlx-accordion__panel--open-default')) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      panel.classList.remove('rlx-accordion__panel--open-default');
    }

    // if there are form steps in here we need to adjust the panel height on step change
    const steps = panel?.querySelectorAll<HTMLElement>('.rlx-form__step');
    steps?.forEach((step) => {
      step.addEventListener('changed', ()=> {
        panel!.style.maxHeight = `${panel!.scrollHeight}px`;
      });
    });

    btn.addEventListener('click', (e)=> {
      e.preventDefault;

      if (panel?.classList.contains('open')) {
        btn.classList.remove('open');
        panel.style.maxHeight = '0';
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
      } else if (panel) {
        btn.classList.add('open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.classList.add('open');
        panel.removeAttribute('aria-hidden');
      }
    });
  });
});

